import * as e from "react";
const t = (c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...c
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9 9V5H5v4h4zm0 10v-4H5v4h4zm10 0v-4h-4v4h4zM18 4v6c0 .55-.45 1-1 1s-1-.45-1-1V4c0-.55.45-1 1-1s1 .45 1 1zm-8 7H4c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1h6c.55 0 1 .45 1 1v6c0 .55-.45 1-1 1zm0 10H4c-.55 0-1-.45-1-1v-6c0-.55.45-1 1-1h6c.55 0 1 .45 1 1v6c0 .55-.45 1-1 1zm10 0h-6c-.55 0-1-.45-1-1v-6c0-.55.45-1 1-1h6c.55 0 1 .45 1 1v6c0 .55-.45 1-1 1z",
      fill: "#292933"
    }
  ),
  /* @__PURE__ */ e.createElement("mask", { id: "apps_svg__a", fill: "#fff" }, /* @__PURE__ */ e.createElement("path", { d: "M14 6h6c.55 0 1 .45 1 1s-.45 1-1 1h-6c-.55 0-1-.45-1-1s.45-1 1-1z" })),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14 6h6c.55 0 1 .45 1 1s-.45 1-1 1h-6c-.55 0-1-.45-1-1s.45-1 1-1z",
      stroke: "#292933",
      strokeWidth: 4,
      mask: "url(#apps_svg__a)"
    }
  )
);
export {
  t as default
};
